// extracted by mini-css-extract-plugin
export default {"betSelector":"BetSelector_betSelector__OL4kw"};